import { Navigate, Route, Routes } from 'react-router-dom'

import AppLayout from './layout/AppLayout.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import ApplicationCreatePage from './pages/applications/ApplicationCreatePage.jsx'
import ApplicationEditPage from './pages/applications/ApplicationEditPage.jsx'
import ApplicationSettingsLayoutPage from './pages/applications/ApplicationSettingsLayoutPage.jsx'
import ApplicationsListPage from './pages/applications/ApplicationsListPage.jsx'
import HomePage from './pages/HomePage.jsx'
import LoginPage from './pages/LoginPage.jsx'
import NotFoundPage from './pages/NotFoundPage.jsx'
import ApplicationConfigsLayoutPage from './pages/applications/configs/ApplicationConfigsLayoutPage.jsx'
import ApplicationGroupConfigsListPage from './pages/applications/configs/ApplicationGroupConfigsListPage.jsx'
import GroupConfigBuilderPage from './pages/applications/configs/GroupConfigBuilderPage.jsx'
import GroupConfigCreatePage from './pages/applications/configs/GroupConfigCreatePage.jsx'
import GroupConfigDetailPage from './pages/applications/configs/GroupConfigDetailPage.jsx'
import ApplicationSegmentsLayoutPage from './pages/applications/segments/ApplicationSegmentsLayoutPage.jsx'
import ApplicationSegmentsListPage from './pages/applications/segments/ApplicationSegmentsListPage.jsx'
import SegmentationCreatePage from './pages/applications/segments/SegmentationCreatePage.jsx'
import SegmentationDetailPage from './pages/applications/segments/SegmentationDetailPage.jsx'
import ApplicationElementsLayoutPage from './pages/applications/elements/ApplicationElementsLayoutPage.jsx'
import ApplicationElementsListPage from './pages/applications/elements/ApplicationElementsListPage.jsx'
import ElementCreatePage from './pages/applications/elements/ElementCreatePage.jsx'
import ElementDetailPage from './pages/applications/elements/ElementDetailPage.jsx'
import ApplicationAbTestsLayoutPage from './pages/applications/abTests/ApplicationAbTestsLayoutPage.jsx'
import ApplicationAbTestsListPage from './pages/applications/abTests/ApplicationAbTestsListPage.jsx'
import AbTestCreatePage from './pages/applications/abTests/AbTestCreatePage.jsx'
import AbTestDetailPage from './pages/applications/abTests/AbTestDetailPage.jsx'
import ApplicationDynamicRulesLayoutPage from './pages/applications/dynamicRules/ApplicationDynamicRulesLayoutPage.jsx'
import ApplicationDynamicRulesListPage from './pages/applications/dynamicRules/ApplicationDynamicRulesListPage.jsx'
import DynamicRuleCreatePage from './pages/applications/dynamicRules/DynamicRuleCreatePage.jsx'
import DynamicRuleDetailPage from './pages/applications/dynamicRules/DynamicRuleDetailPage.jsx'
import ApplicationSectionPage from './pages/applications/ApplicationSectionPage.jsx'
import ApplicationForceUpdaterPage from './pages/applications/forceUpdater/ApplicationForceUpdaterPage.jsx'
import ApplicationValidatorPage from './pages/applications/validator/ApplicationValidatorPage.jsx'
import ApplicationSettingsPage from './pages/applications/ApplicationSettingsPage.jsx'
import ApplicationSchedulerLayoutPage from './pages/applications/scheduler/ApplicationSchedulerLayoutPage.jsx'
import ApplicationSchedulerListPage from './pages/applications/scheduler/ApplicationSchedulerListPage.jsx'
import SchedulerCreatePage from './pages/applications/scheduler/SchedulerCreatePage.jsx'
import SchedulerDetailPage from './pages/applications/scheduler/SchedulerDetailPage.jsx'
import ApplicationConfigTesterLayoutPage from './pages/applications/configTester/ApplicationConfigTesterLayoutPage.jsx'
import ApplicationConfigTesterListPage from './pages/applications/configTester/ApplicationConfigTesterListPage.jsx'
import ConfigTesterCreatePage from './pages/applications/configTester/ConfigTesterCreatePage.jsx'
import ConfigTesterDetailPage from './pages/applications/configTester/ConfigTesterDetailPage.jsx'
import ApplicationConfigVersionsPage from './pages/applications/configVersions/ApplicationConfigVersionsPage.jsx'
import WorkGroupsListPage from './pages/workGroups/WorkGroupsListPage.jsx'
import WorkGroupCreatePage from './pages/workGroups/WorkGroupCreatePage.jsx'
import WorkGroupDetailPage from './pages/workGroups/WorkGroupDetailPage.jsx'
import UsersListPage from './pages/users/UsersListPage.jsx'
import UserCreatePage from './pages/users/UserCreatePage.jsx'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/applications" element={<ApplicationsListPage />} />
          <Route path="/applications/new" element={<ApplicationCreatePage />} />
          <Route path="/applications/:id" element={<ApplicationSettingsLayoutPage />}>
            <Route index element={<Navigate to="settings" replace />} />
            <Route path="settings" element={<ApplicationSettingsPage />} />
            <Route path="configs" element={<ApplicationConfigsLayoutPage />}>
              <Route index element={<ApplicationGroupConfigsListPage />} />
              <Route path="new" element={<GroupConfigCreatePage />} />
              <Route path=":groupConfigId" element={<GroupConfigDetailPage />} />
              <Route path=":groupConfigId/builder" element={<GroupConfigBuilderPage />} />
            </Route>
            <Route path="elements" element={<ApplicationElementsLayoutPage />}>
              <Route index element={<ApplicationElementsListPage />} />
              <Route path="new" element={<ElementCreatePage />} />
              <Route path=":elementId" element={<ElementDetailPage />} />
            </Route>
            <Route path="ab-tests" element={<ApplicationAbTestsLayoutPage />}>
              <Route index element={<ApplicationAbTestsListPage />} />
              <Route path="new" element={<AbTestCreatePage />} />
              <Route path=":abTestId" element={<AbTestDetailPage />} />
            </Route>
            <Route path="dynamic-rules" element={<ApplicationDynamicRulesLayoutPage />}>
              <Route index element={<ApplicationDynamicRulesListPage />} />
              <Route path="new" element={<DynamicRuleCreatePage />} />
              <Route path=":dynamicRuleId" element={<DynamicRuleDetailPage />} />
            </Route>
            <Route
              path="segments"
              element={<ApplicationSegmentsLayoutPage />}
            >
              <Route index element={<ApplicationSegmentsListPage />} />
              <Route path="new" element={<SegmentationCreatePage />} />
              <Route path=":segmentationId" element={<SegmentationDetailPage />} />
            </Route>
            <Route
              path="events"
              element={
                <ApplicationSectionPage
                  sectionTitle="Events"
                  sectionDescription="In-app event templates and integration status."
                />
              }
            />
            <Route path="force-update" element={<ApplicationForceUpdaterPage />} />
            <Route path="config-versions" element={<ApplicationConfigVersionsPage />} />
            <Route path="validator" element={<ApplicationValidatorPage />} />
            <Route
              path="knowledge-hub"
              element={
                <ApplicationSectionPage
                  sectionTitle="Knowledge Hub"
                  sectionDescription="Knowledge base and guidance for application configuration."
                />
              }
            />
            <Route path="scheduler" element={<ApplicationSchedulerLayoutPage />}>
              <Route index element={<ApplicationSchedulerListPage />} />
              <Route path="new" element={<SchedulerCreatePage />} />
              <Route path=":schedulerId" element={<SchedulerDetailPage />} />
            </Route>
            <Route path="config-tester" element={<ApplicationConfigTesterLayoutPage />}>
              <Route index element={<ApplicationConfigTesterListPage />} />
              <Route path="new" element={<ConfigTesterCreatePage />} />
              <Route path=":configTesterId" element={<ConfigTesterDetailPage />} />
            </Route>
          </Route>
          <Route path="/applications/:id/edit" element={<ApplicationEditPage />} />
          <Route path="/work-groups" element={<WorkGroupsListPage />} />
          <Route path="/work-groups/new" element={<WorkGroupCreatePage />} />
          <Route path="/work-groups/:id" element={<WorkGroupDetailPage />} />
          <Route path="/users/new" element={<UserCreatePage />} />
          <Route path="/users" element={<UsersListPage />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
